// 导入组件库
import {createApp} from 'vue';
import App from './App.vue';

import {createHead} from '@vueuse/head';

import router from './router';

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';

import Vant from 'vant';
import 'vant/lib/index.css';
import {configure, defineRule} from 'vee-validate';
import {localize, setLocale} from '@vee-validate/i18n';
import {required, email, min, numeric, max} from '@vee-validate/rules';
// 配置本地化（错误消息）
configure({
    generateMessage: localize('zh_CN', {
        messages: {
            required: '该字段不能为空',
            email: '请输入有效的邮箱地址',
            min: '最少输入{length}个字符',
            max: '最多输入{length}个字符',
            numeric: '必须是数字',
        },
    }),
});
setLocale('zh_CN');


import $http from './utils/axios'; // 引入配置好的Axios实例

import './utils/wechatSDK'; //引入wx.js

import Vcode from "vue3-puzzle-vcode";

import PhotoPreview from 'vue3-photo-preview';
import 'vue3-photo-preview/dist/index.css';
// 自定义配置（可选）
const PhotoPreview_options = {
    maxSpreadZoom: 2, // 预览图最大的倍数
    fullscreenEl: true, // 是否显示右上角全屏按钮
};


import EasyLightbox from 'vue-easy-lightbox';
import "vue-easy-lightbox/dist/external-css/vue-easy-lightbox.css"


import lazyPlugin from 'vue-lazyload';


import './assets/css/main.css';

const app = createApp(App);
// 创建Vue应用实例

app.use(Vcode);

app.use(router);
// 注册router
app.use(Vant);
// 注册Vant组件
app.use(ElementPlus)
// ElementPlus
app.use(PhotoPreview, PhotoPreview_options);
//vue3-photo-preview

app.use(EasyLightbox);
//vue-easy-lightbox

//懒加载
app.use(lazyPlugin, {
    loading: "@/assets/images/default.png",//可以指定加载中的图像
    error: "@/assets/images/err.png",//可以指定加载失败的图像
});
// 挂载Vue应用实例
app.config.globalProperties.$http = $http; // 挂载到全局属性上

app.use(createHead())


app.mount('#app');
